import { render, staticRenderFns } from "./TermsCard.vue?vue&type=template&id=45eeda7d&scoped=true&"
import script from "./TermsCard.vue?vue&type=script&lang=js&"
export * from "./TermsCard.vue?vue&type=script&lang=js&"
import style0 from "./TermsCard.vue?vue&type=style&index=0&id=45eeda7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eeda7d",
  null
  
)

export default component.exports